<template>
  <div>
    <table v-loading="loading" width="100%">
      <thead>
        <tr>
          <td>更新包版本号</td>
          <td>更新时间</td>
          <td>更新源IP</td>
          <td width="20%">更新状态</td>
          <td width="21%">状态详情</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in data" :key="index">
          <td>{{item.file_version}}</td>
          <td>{{formatDate(new Date(item.time))}}</td>
          <td>{{item.remote_ip}}</td>
          <td>{{item.resp_code === 200 ? '已获取' : '未获取'}}</td>
          <td>{{handleStatus(item.resp_code)}}</td>
        </tr>
        <tr v-if="!data.length">
          <td colspan="5">暂无数据</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatDate } from '@/util/common'
export default {
  props: {
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    formatDate,

    /**
     * 处理响应状态
     * @param code: number
     */
    handleStatus (code) {
      switch (code) {
        case 200:
          return '请求成功'
        case 201:
          return '无需更新'
        case 431:
          return '用户名或密码错误'
        case 433:
          return '服务器错误'
        case 434:
          return 'IP地址无效'
        case 435:
          return '服务不存在'
        case 436:
          return '服务已过期'
        case 437:
          return '请求参数错误'
        case 404:
          return '请求路径不正确'
        case 400:
          return '请求参数错误'
        case 401:
          return '身份认证失败'
        case 403:
          return '无权访问'
        case 422:
          return '请求内容校验失败'
        case 429:
          return '请求过于频繁'
        case 500:
        case 502:
        case 503:
          return '服务暂时不可用'
        default:
          return '请求失败'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  tr {
    background: #ffffff;
    td {
      vertical-align: middle;
      text-align: center;
    }
  }
  thead {
    td {
      height: 66px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
    }
  }
  tbody {
    tr {
      &:nth-of-type(odd) {
        background: #f6faff;
      }
      td {
        height: 54px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(29, 36, 60, 1);
      }
    }
  }
}
</style>
